
// This function can't use hooks, so it's just a pure utility.
const handleUnauthorized = () => {
    console.log("401 Unauthorized detected. Redirecting to login.");
    // Here you might also want to clear any context state if possible,
    // but a hard redirect is simplest.
    window.location.href = '/'; 
  };
  
  /**
   * Creates a pre-configured API client.
   * You call this function from INSIDE your component to get an object
   * with .get(), .post(), etc. methods that are already set up
   * with the current JWT from your context.
   *
   * @param {string} apiJwt - The JWT token from your AuthContext.
   * @returns {object} An object with methods like get, post, etc.
   */
  export const createApiClient = (apiJwt) => {
    // This is the core fetch function that will be used by get, post, etc.
    const request = async (endpoint, options = {}) => {
      // We assume the JWT is required for all calls.
      if (!apiJwt) {
        throw new Error("API call failed: No authentication token provided.");
      }
  
      const defaultHeaders = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiJwt}`,
      };
  
      const config = {
        ...options,
        headers: {
          ...defaultHeaders,
          ...options.headers,
        },
        credentials: 'include', // Important for sending the HttpOnly session cookie
      };
  
      try {
        const response = await fetch(endpoint, config);
  
        if (response.status === 401) {
          handleUnauthorized();
          throw new Error("Unauthorized");
        }
  
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `API Error: ${response.status}`);
        }
        
        // For calls that don't return a body (like DELETE or 204 No Content)
        if (response.status === 204) {
            return null;
        }
  
        // Automatically parse JSON for convenience
        return response
  
      } catch (error) {
        console.error(`API request to ${endpoint} failed:`, error);
        throw error; // Re-throw for the component to handle
      }
    };
  
    // Return an object with convenient methods
    return {
      get: (endpoint) => request(endpoint, { method: 'GET' }),
      post: (endpoint, body) => request(endpoint, { method: 'POST', body: JSON.stringify(body) }),
      // You can add put, delete, etc. here as needed
    };
  };
  
  export const fetchInitialJwt = async () => {
    const jwtUrl = process.env.REACT_APP_JWT_URL;
    const username = process.env.REACT_APP_JWT_USERNAME;
    const password = process.env.REACT_APP_JWT_PASSWORD;
  
    // ... (the rest of your fetchJwtToken logic to get the token) ...
    // ... on success, it should return the token string ...
    const resp = await fetch(jwtUrl, {
      method: 'POST',
      headers: { 'Authorization': 'Basic ' + btoa(`${username}:${password}`) }
    });
    if (!resp.ok) throw new Error("Failed to get initial JWT");
    const data = await resp.json();
    return data.token;
  };

// // send auth token
// export const fetchJwtToken = async () => {
//     const jwtUrl = process.env.REACT_APP_JWT_URL;
//     const username = process.env.REACT_APP_JWT_USERNAME;
//     const password = process.env.REACT_APP_JWT_PASSWORD;

//     // Check if environment variables are loaded correctly
//     if (!jwtUrl || !username || !password) {
//         console.error("JWT environment variables are not set!");
//         // Return a rejected promise or throw an error to be caught
//         throw new Error("Missing JWT configuration."); 
//     }

//     try {
//         // Correct fetch syntax with two arguments: url and an options object
//         const resp = await fetch(jwtUrl, {
//             // Most authentication endpoints use POST, not GET. Double-check this.
//             method: 'POST', 
//             headers: {
//                 // Manually create the 'Authorization' header for Basic Auth
//                 // btoa() creates a base-64 encoded string
//                 'Authorization': 'Basic ' + btoa(`${username}:${password}`),
//                 'Content-Type': 'application/json' // Often required by auth endpoints
//             }
//         });

//         // Check if the server responded with an error (like 404, 401, etc.)
//         if (!resp.ok) {
//             // Log the error response text for debugging
//             const errorText = await resp.text();
//             console.error("Failed to fetch JWT token. Status:", resp.status, "Response:", errorText);
//             throw new Error(`Server responded with status ${resp.status}`);
//         }

//         // Correctly parse the JSON body from the response
//         const data = await resp.json();

//         // Now you can safely access the token
//         return data.token;

//     } catch (error) {
//         console.error("An error occurred in fetchJwtToken:", error);
//         // Re-throw the error so the calling function knows something went wrong
//         throw error;
//     }
// };

// Function to handle global 401 Unauthorized errors
// export const handleUnauthorized = () => {
//     console.log("401 Unauthorized detected. Clearing session and redirecting.");
//      window.location.href = '/'; // Redirect to the login page (root path)
// };

// // Generic API fetch wrapper
// export const apiFetch = async (url, options) => {
//     const token = await fetchJwtToken();
//     const defaultHeaders = {
//         'Content-Type': 'application/json',
//     };

//     const newOptions = {
//         ...options,
//         headers: {
//             ...defaultHeaders,
//             ...options.headers,
//             ...(token && { 'Authorization': `Bearer ${token}` }),
//         },
//         credentials: 'include', 
//     };

//     try {
//         const response = await fetch(url, newOptions);

//         if (response.status === 401) {
//             handleUnauthorized();
//             // Re-throw or handle specific 401 message
//             const errorData = await response.json().catch(() => ({ message: "Unauthorized" }));
//             throw new Error(errorData.message || "Unauthorized access.");
//         }

//         // Handle other non-OK responses
//         if (!response.ok) {
//             const errorData = await response.json().catch(() => ({ message: "An API error occurred." }));
//             throw new Error(errorData.message || errorData.error || `API Error: ${response.status}`);
//         }

//         return response; // Return the response object for further processing (e.g., .json() or .blob())
//     } catch (error) {
//         console.error("API call error:", error);
//         // If it's the specific error from handleUnauthorized, rethrow it for consistent handling
//         if (error.message === "Unauthorized access.") { throw error; }
//         // For network errors etc., rethrow generic error
//         throw new Error(error.message || "Network error. Please check your connection.");
//     }
// };

// export const apiAuth = async (url, options, token) => {
//     const defaultHeaders = {
//         'Content-Type': 'application/json',
//     };

//     const newOptions = {
//         ...options,
//         headers: {
//             ...defaultHeaders,
//             ...options.headers,
//             ...(token && { 'Authorization': `Bearer ${token}` }),
//         },
//         credentials: 'include', 
//     };

//     try {
//         const response = await fetch(url, newOptions);

//         if (response.status === 401) {
//             handleUnauthorized();
//             // Re-throw or handle specific 401 message
//             const errorData = await response.json().catch(() => ({ message: "Unauthorized" }));
//             throw new Error(errorData.message || "Unauthorized access.");
//         }

//         // Handle other non-OK responses
//         if (!response.ok) {
//             const errorData = await response.json().catch(() => ({ message: "An API error occurred." }));
//             throw new Error(errorData.message || errorData.error || `API Error: ${response.status}`);
//         }

//         return response; // Return the response object for further processing (e.g., .json() or .blob())
//     } catch (error) {
//         console.error("API call error:", error);
//         // If it's the specific error from handleUnauthorized, rethrow it for consistent handling
//         if (error.message === "Unauthorized access.") { throw error; }
//         // For network errors etc., rethrow generic error
//         throw new Error(error.message || "Network error. Please check your connection.");
//     }
// };

